import React from "react";

//lets make coming soon big
function CollaborationHubComponent() {
  return (
    <div className="flex flex-col text-2xl font-bold min-h-screen flex-grow mx-auto px-20 py-8 justify-center items-center">
      apun end pay bny ga... yaha ee dikhssdfjksdfghsdjfgsday ga .............
    </div>
  );
}

export default CollaborationHubComponent;
